<template>
  <el-container>
    <el-header height="auto">
      <el-card>Base64（基底64）是一种基于64个可打印字符来表示二进制数据的表示方法。每6个比特为一个单元，对应某个可打印字符。3个字节相当于24个比特，对应于4个Base64单元，即3个字节可由4个可打印字符来表示。在Base64中的可打印字符包括字母A-Z、a-z、数字0-9，这样共有62个字符，此外两个可打印符号在不同的系统中而不同。一些如uuencode的其他编码方法，和之后BinHex的版本使用不同的64字符集来代表6个二进制数字，但是不被称为Base64。Base64常用于在通常处理文本数据的场合，表示、传输、存储一些二进制数据，包括MIME的电子邮件及XML的一些复杂数据。</el-card>
    </el-header>
    <el-main>
      <el-form
        size="small"
        :inline="true"
        :model="form"
        ref="form"
        :label-position="labelPosition"
        :label-width="labelWidth"
        @submit.native.prevent
      >
        <el-form-item>
          <el-button type="primary" @click="encode">编码</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="decode">解码</el-button>
        </el-form-item>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-input
              type="textarea"
              :autosize="autosize"
              :disabled="form.disable_input"
              v-model="form.input"
              placeholder="请输入待编码、解码的内容，结果在右侧框输出"
            ></el-input>
          </el-col>
          <el-col :span="12">
            <el-input
              type="textarea"
              :autosize="autosize"
              v-model="form.output"
              placeholder=""
            ></el-input>
          </el-col>
        </el-row>
      </el-form>
    </el-main>
  </el-container>
</template>


<script>
export default {
  name: "Base64",
  data() {
    return {
      form: this.initform
    };
  },
  props: {
    labelPosition: { type: String, default: "left" },
    labelWidth: { type: String, default: "auto" },
    autosize: {
      type: Object,
      default: function() {
        return { minRows: 20, maxRows: 35 };
      }
    },
    initform: {
      type: Object,
      default: function() {
        return {
          input: "",
          disable_input: false,
          output: "",
          file: null
        };
      }
    }
  },
  methods: {
    encode: function() {
      this.form.output = btoa(unescape(encodeURIComponent(this.form.input)))
    },
    decode: function() {
      this.form.output = decodeURIComponent(escape(atob(this.form.input)));
    }
  }
};
</script>
<style scoped>
</style>
